import { ArticleCardType } from "@/src/types";
import React from "react";
import ArticleCard from "./ArticleCard2";

export interface ArticleGridListProps {
  articles: ArticleCardType[];
}

const ArticleGridList = ({ articles }: ArticleGridListProps) => {
  return (
    <div
      className={`grid grid-rows-${Math.ceil(
        articles.length / 2
      )} gap-2 md:gap-4 articles-list count-${articles.length}`}
    >
      {articles.map(function (article) {
        return <ArticleCard post={article} key={article.id} />;
      })}
    </div>
  );
};

export default ArticleGridList;
